<template>
    <v-menu v-if="!!EffectiveUsername" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"
                   v-on="on"
                   text>
                <v-badge overlap left color="transparent">
                    <v-avatar size="40">
                        <img :src="`https://enterprisedata-api-da.azurewebsites.net/data/fetch/users/photo/${EffectiveUsername}`" :alt="EffectiveDisplayName" />
                    </v-avatar>
                </v-badge>
                <span class="hidden-sm-and-down pl-2">{{ EffectiveDisplayName }}</span>
            </v-btn>
        </template>
        <v-list v-if="IsAuthorised" dense>
            <v-list-item>
                <v-list-item-action class="mr-2">
                    <v-switch v-model="useDarkTheme" dense inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ useDarkTheme ? 'Go Light' : 'Go Dark' }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import { eventBus } from '@/main'

    import appApiMixin from '@/views/components/mixins/appApi.js'
    import userThemeMixin from '@/views/components/mixins/userTheme.js'

    export default {
        mixins: [
            appApiMixin,
            userThemeMixin,
        ],
        data() {
            return {
                useDarkTheme: false,
            }
        },
        mounted() {
            eventBus.$off('user-theme-fetch:success').$on('user-theme-fetch:success', () => this.$vuetify.theme.dark = this.useDarkTheme);
            this.LoadTheme();
        },
        watch: {
            useDarkTheme(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.$vuetify.theme.dark = newValue;
                    this.SaveTheme();
                }
            }
        }
    }
</script>
